import {replaceElementInArray} from "@web-libs/util/arrays/array.functions";
import {
    _addMessages,
    _findChatroom,
    _findChatroomIndex,
    _incrementUnreadMessages,
    _resetUnreadMessages,
    _updateChatroom,
    ChatroomUpdate,
} from "@web-libs/features/chat/domain/chatroom.functions";
import {Chat} from "@web-libs/features/chat/domain/types/chat.type";
import {Chatroom} from "@web-libs/features/chat/domain/types/chatroom.type";
import {ChatMessage} from "@web-libs/features/chat/domain/types/chat-message.types";

/**
 *  PUBLIC FUNCTIONS
 */
export const addMessages = (chat: Chat, chatroomId: string, messages: ChatMessage[]): Chat =>
    _runChatroomUpdate(chat, chatroomId, chatroom => _addMessages(chatroom, messages));

export const removeMessage = (chat: Chat, chatroomId: string, messageId: string): Chat => {
    const chatroom = _findChatroom(chat.chatrooms, chatroomId);
    const updatedChatroom = {
        ...chatroom,
        messages: chatroom.messages.filter(message => message.messageId !== messageId),
    };
    return _setChatroom(chat, updatedChatroom);
}

export const updateChatroom = (chat: Chat, update: ChatroomUpdate): Chat =>
    _runChatroomUpdate(chat, update.id, _chatroom => _updateChatroom(_chatroom, update));

export const resetUnreadMessages  = (chat: Chat, chatroomId: string): Chat =>
    _runChatroomUpdate(chat, chatroomId, _resetUnreadMessages);

export const incrementUnreadMessages = (chat: Chat, chatroomId: string): Chat =>
    _runChatroomUpdate(chat, chatroomId, _incrementUnreadMessages);

export const findChatroom = (chat: Chat, chatroomId: string): Chatroom =>
    _findChatroom(chat.chatrooms, chatroomId);

export const isUnreadMessage = (chat: Chat): boolean =>
    chat.chatrooms.some(chatroom => chatroom.unreadMessages > 0);

/**
 *  PRIVATE FUNCTIONS
 */
function _runChatroomUpdate(chat: Chat, chatroomId: string, update: (chatroom: Chatroom) => Chatroom): Chat {
    const chatroom = _findChatroom(chat.chatrooms, chatroomId);
    const updatedChatroom = update(chatroom);
    return _setChatroom(chat, updatedChatroom);
}

function _setChatroom(chat: Chat, chatroom: Chatroom): Chat {
    return {
        ...chat,
        chatrooms: _replaceChatroom(chat.chatrooms, chatroom),
    };
}

function _replaceChatroom(chatrooms: Chatroom[], chatroom: Chatroom) {
    const chatroomIndex = _findChatroomIndex(chatrooms, chatroom.id);
    return replaceElementInArray(chatrooms, chatroom, chatroomIndex)
}
